import { scenarios } from '@/mocks/scenarios';

export default function Scenarios() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-medium mb-4">
            mrds 应用场景
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            多行业覆盖，满足多样化业务需求
          </h2>
          <p className="text-foreground-500 text-base max-w-[600px] mx-auto leading-relaxed">
            mrds 已成功应用于金融、医疗、电商、制造等多个行业，为不同领域的客户创造真实价值
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {scenarios.map((scenario) => (
            <div
              key={scenario.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={scenario.image}
                  alt={scenario.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-background-50/20 backdrop-blur-sm flex items-center justify-center">
                      <i className={`${scenario.icon} text-background-50 text-sm`}></i>
                    </div>
                    <span className="text-background-50 font-heading font-semibold text-sm">{scenario.title}</span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {scenario.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}